<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-textarea
                required
                autocomplete="off"
                label="Atsisakymo pagrindas"
                type="text"
                :disabled="modeReadonly"
                v-model="formData.title_lt"
                :maxlength="200"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                required
                autocomplete="off"
                label="Aprašymas (LT)"
                type="text"
                :disabled="modeReadonly"
                v-model="formData.description"
                :maxlength="2000"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                required
                autocomplete="off"
                label="Aprašymas (EN)"
                type="text"
                :disabled="modeReadonly"
                v-model="formData.description_en"
                :maxlength="2000"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                :items="enumsClassifiers.rejectReasonType"
                enums
                multiple
                itemvalue="value"
                itemtext="text"
                label="Požymis"
                v-model="formData.type"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-text-field
                label="Kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'

export default {
  name: 'AdminRejectReasonForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      code: '',
      enumsClassifiers: [],
    }
  },
  computed: {
    modeReadonly() {
      return false
    },

    getId() {
      return this.$route.params.id || null
    },

    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti atsisakymo pagrindą`)
      } else {
        return this.$t(`Naujas atsisakymo pagrindas`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
    this.enumsClassifiers = Enums
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierRejectReasons' })
    },
    getData() {
      this.pageloading = true

      this.$axios
        .get(`reject-reasons/${this.getId}`)
        .then((res) => {
          this.formData = res.data.rejectReason
          this.code = this.formData.code
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          formData.code = this.code
          let url = `reject-reasons`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
